import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TranslationState } from './initialTranslationState';

export const SelectTranslations = createFeatureSelector<TranslationState>('translation');
